import { countConversationsCreated } from '../queries/countConversationsCreated'

export const totalConversationsCreatedGauge = {
  description: 'Total amount of incoming conversations.',
  queries: [countConversationsCreated],
  title: 'Conversations',
}
